import React from "react";
import { getYear } from "date-fns";
import moment from "moment";

const generateButtonHtml = url => {
  return {__html:`
      <!--[if mso]> 
        <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${url}" style="height:40px;v-text-anchor:middle;width:300px;" arcsize="10%" stroke="f" fillcolor="#005AA9"> 
          <w:anchorlock/> 
            <center style="color:#ffffff;font-family:sans-serif;font-size:16px;font-weight:bold;"> 
              View Report 
            </center> 
        </v:roundrect> 
      <![endif]-->
      <![if !mso]>
        <table style="margin: 0 auto;" cellspacing="0" cellpadding="0"> <tr> 
          <td align="center" width="300" height="40" bgcolor="#005AA9" style="-webkit-border-radius: 5px; white-space: initial; -moz-border-radius: 5px; border-radius: 5px; color: #ffffff; display: block;">
            <a href="${url}" class="do-not-click" style="font-size:16px; font-weight: bold; font-family:sans-serif; text-decoration: none; line-height:40px; width:100%; display:inline-block">
              <span style="color: #ffffff;">
                View Report
              </span>
            </a>
          </td> 
        </tr> </table> 
      <![endif]>       
      `};
};

const getFrequency = freq => {
  switch (freq) {
    case "semi-annually":
      return "Semi-Annual";
    case "annually":
      return "Annual";
    case "monthly":
      return "Monthly";
    case "quarterly":
      return "Quarterly";
    default:
      return "";
  }
};

const ShareEmailTemplate = ({ staticElement, userName, company, taskDetails, rgiId, expirationDate, pin }) => {
  return (
    <div ref={staticElement} style={{ display: "none" }}>
      <br />
      <table align="center" style={{ maxWidth: 570, fontFamily: "Work Sans", margin: "38px auto", padding: 20, borderRadius: 8, border: "1px solid #DADCE0", backgroundColor: "#FAFAFA" }}>
        <tr>
          <p style={{ fontSize: 16, width: 400, marginLeft: "auto", marginRight: "auto", textAlign: "center", color: "black", marginBottom: 20, marginTop: 0 }}>{userName} from {company?.name} has shared {getFrequency(taskDetails?.reportGroup?.frequency)} Reporting for {taskDetails.deal.name}.</p>
        </tr>
        <tr style={{ textAlign: "center", marginBottom: 20 }}>
          <td style={{ whiteSpace: "initial" }} height="100" dangerouslySetInnerHTML={generateButtonHtml(`${window.location.origin}/lenderReportingDashboard/lender/${rgiId}/`)}></td>
        </tr>
        <tr style={{ marginBottom: 25, width: 422, marginLeft: "auto", marginRight: "auto", textAlign: "center", color: "black", fontSize: 14 }}>
          <table>
            <tr>
              <td style={{ textAlign: "center" }}><p>This page is secure and requires the following pin for access, and will expire on {moment(expirationDate).format("MM/DD/YYYY")}</p></td>
            </tr>
            <tr style={{ fontSize: 16, color: "blue" }}>
              <td style={{ textAlign: "center" }}>{pin}</td>
            </tr>
          </table>
        </tr>
        <tr style={{ textAlign: "center", color: "#5F6368", fontSize: 14 }}>
          <table>
            <tr>
              <td style={{ fontSize: 16, color: "black", marginBottom: 12, marginRight: -6, textAlign: "center" }}>Powered by &nbsp;
                <img height="18" width="100" src="https://i.ibb.co/QfK0Fgp/loanboss-Logo-Black.png" style={{ width: 100, marginBottom: -3, marginLeft: 6 }} alt="loanboss-Logo-Black"></img>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>(980) 701-0180</td>
            </tr>
            <tr>
              <td style={{ margin: "4px 0 10px 0", textAlign: "center" }}>support@loanboss.com</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>{`© ${getYear(new Date())} LoanBoss LLC. All rights reserved. 1300 South Mint Street, Suite 410, Charlotte NC 28203.`}</td>
            </tr>
          </table>
        </tr>
      </table>
    </div>
  );
};

export default ShareEmailTemplate;
